export enum ButtonTypes {
  None = 'none',
  Private = 'private',
  Extension = 'extension',
  Park = 'park',
  Login = 'login',
  Flag = 'flag',
  Speed = 'speed',
  HuntGroup = 'hunt',
  AgentGroup = 'queue',
  Local = 'local',
  Attendant = 'attendant',
  Hunt = 'hunt',
  Queue = 'queue',
  Conference = 'conference',
  IvrNode = 'ivrnode',
  CoLine = 'coline',
  Page = 'page',
  Intercom = 'intercom',
  Vm = 'vm',
  Dnd = 'dnd',
  Redirect = 'redirect',
  Group = 'group',
  Cell = 'cell',
  Url = 'url',
  Record = 'record',
  Prefix = 'prefix',
  Dtmf = 'dtmf',
  Yealink = 'yealink',
}
